import { keepPreviousData, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { Skill } from '@/common/api/types/skills';
import { capacityQueryKeys } from '@/features/settings/capacity/queryKeys';
import { type SkillSearchParams, SkillsApi } from '@/features/settings/skills/api';

export const getSkillsQueryOptions = () => {
  return {
    queryKey: capacityQueryKeys.skills.all(),
    queryFn: async () => {
      return await SkillsApi.getSkills();
    },
  };
};

export const getSearchSkillsQueryOptions = ({
  query = '',
  isCritical,
  activeOnly,
}: SkillSearchParams = {}) => {
  const params = {
    query,
    ...(isCritical !== undefined && { isCritical }),
    ...(activeOnly === false && { activeOnly }),
  };

  return {
    queryKey: capacityQueryKeys.skills.search(params),
    queryFn: () => SkillsApi.searchSkills(params),
    placeholderData: keepPreviousData,
  };
};

export const useSkillsQuery = (options: Partial<UseQueryOptions<Skill[]>> = {}) => {
  return useQuery({ ...getSkillsQueryOptions(), ...options });
};

export const useSearchSkillsQuery = (params: SkillSearchParams = {}) => {
  return useQuery({ ...getSearchSkillsQueryOptions(params) });
};
